import { Core } from "@faire/design-tokens";
import { Button } from "@faire/web/slate/Button";
import { Lock } from "@faire/web/slate/icons/foundation/Lock";
import { Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import privacy from "@faire/web-api--source/routes/www/privacy";
import React, { type JSX } from "react";

export const PrivacyPolicyNote: React.FC = () => {
  return (
    <Row data-test-id="privacy-policy-note">
      <Lock lockType="roundedSquare" fontSize="14px" />
      <Spacer width="1x" />
      <Typography variant="labelSansRegular" color={Core.text.subdued}>
        <StrictLocalMsg
          defaultMessage="By proceeding you are acknowledging our Privacy Policy. Learn more about how we use and protect your data at Faire. <LinkFormatting>Privacy at Faire</LinkFormatting>"
          values={{ LinkFormatting }}
          description={{
            text: "Message to prompt new users that are signing up to learn more about company data policy.",
            img: "https://cdn.faire.com/fastly/7fadddc4e0e2b848b73c15a90106fd2852b68eda1ec376d4026f46a58252a5ad.png",
          }}
        />
      </Typography>
    </Row>
  );
};

const LinkFormatting = (chunks: JSX.Element) => (
  <Button variant="tertiary" linkTo={privacy()}>
    {chunks}
  </Button>
);
